import { FC } from "react";

type ChevronOthersProps = {
  isOpen: boolean;
};

const ChevronOthers: FC<ChevronOthersProps> = ({ isOpen }) => {
  return (
    <>
        <svg
            className={`min-w-12px ${isOpen ? "rotate-180" : "rotate-0"}`}
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M10.5 4.0575L9.4425 3L6 6.435L2.5575 3L1.5 4.0575L6 8.5575L10.5 4.0575Z" fill="#757575"></path>
        </svg>
    </>
  );
};

export default ChevronOthers;